import { z } from 'zod';
import { InvoiceCheckFrequency, POCheckFrequency } from '../../../types';

export const ERPGatewayConfigurationFormSchema = z.object({
    CompanyId: z.number(),
    InvoiceProfileId: z.number().nullable(), // TODO: required for create?
    BuyerDestinationProfileId: z.number().nullable(), // TODO: required for create?
    InvoiceCheckFrequency: z.nativeEnum(InvoiceCheckFrequency).nullable(),
    InvoiceCheckTimeOfDay: z.string().trim().min(1, { message: 'Invoice Check Time Of Day is required' }), // TODO: is this required?
    POCheckFrequency: z.nativeEnum(POCheckFrequency).nullable(),
    POCheckTimeOfDay: z.string().trim().min(1, { message: 'PO Check Time Of Day is required' }), // TODO: is this required?
    ERPName: z.string().trim().min(1, { message: 'ERP Name is required' }),
    ERPVersion: z.string().trim().min(1, { message: 'ERP Version is required' }),
    InvoiceWorkingDirectory: z.string().trim().min(1, { message: 'Invoice Working Directory is required' }),
    POWorkingDirectory: z.string().trim().min(1, { message: 'PO Working Directory is required' }),
    ERPConnectionInfo: z
        .object({
            root: z.record(z.string(), z.string()), // XML fields
        })
        .nullable(),
    Active: z.boolean(),
});

export type ERPGatewayConfigurationFormViewModel = z.infer<typeof ERPGatewayConfigurationFormSchema>;

// TODO: make common generic type for XML fields?
export interface ERPXmlFieldStructure {
    root: Record<string, string>;
}

export interface ERPGatewayConfigurationViewModel {
    Id: number | null;
    CompanyId: number;
    InvoiceProfileId: number | null;
    BuyerDestinationProfileId: number | null;
    CreatedTime?: Date;
    LastUpdateDate?: Date;
    InvoiceCheckFrequency: number | null;
    InvoiceCheckFrequency_US?: string;
    InvoiceCheckTimeOfDay: string;
    POCheckFrequency: POCheckFrequency | null;
    POCheckFrequency_US?: string;
    POCheckTimeOfDay: string;
    ERPName: string;
    ERPVersion: string;
    InvoiceWorkingDirectory: string;
    POWorkingDirectory: string;
    ERPConnectionInfo: ERPXmlFieldStructure | null;
    LastHealthCheck?: Date;
    Active: boolean;
}
